module.exports = __webpack_public_path__ + "img/head-img1.aa2058e8.png";